var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items && _vm.items.length > 0
    ? _c(
        "v-list-group",
        {
          attrs: { "no-action": "", "prepend-icon": _vm.$MDI.History },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "template",
            { slot: "activator" },
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v("\n                History\n            "),
                  ]),
                  _vm._v(" "),
                  _vm.drawer
                    ? _c(
                        "v-list-item-subtitle",
                        {
                          staticClass: "ml-n1",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              style: { opacity: _vm.page == 0 ? 0.6 : 1 },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.previous()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticStyle: { transform: "inherit" } },
                                [_vm._v(_vm._s(_vm.$MDI.ChevronLeft))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              style: {
                                opacity:
                                  (_vm.page + 1) * _vm.limit >= _vm.items.length
                                    ? 0.6
                                    : 1,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.next()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticStyle: { transform: "inherit" } },
                                [_vm._v(_vm._s(_vm.$MDI.ChevronRight))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(
            _vm.items.slice(_vm.page * _vm.limit, (_vm.page + 1) * _vm.limit),
            function (child) {
              return _c(
                "div",
                { key: child.id, staticClass: "history-row" },
                [
                  _c(
                    "v-list-item",
                    {
                      class: {
                        "list__item--highlighted": child.id == _vm.current,
                      },
                      staticStyle: { "padding-left": "16px" },
                      attrs: { to: _vm.formattedRoute(child) },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _vm.jobStatus(child.id) == "COMPLETE" &&
                          _vm.drawableType(child.id)
                            ? _c("history-avatar", {
                                attrs: {
                                  hash: child.id,
                                  type: _vm.drawableType(child.id),
                                },
                              })
                            : _vm.jobStatus(child.id) == "COMPLETE"
                            ? _c("identicon", {
                                attrs: { hash: child.id, size: 32 },
                              })
                            : _vm.jobStatus(child.id) == "RUNNING"
                            ? _c("v-icon", { attrs: { size: 32 } }, [
                                _vm._v(_vm._s(_vm.$MDI.ClockOutline)),
                              ])
                            : _vm.jobStatus(child.id) == "PENDING"
                            ? _c("v-icon", { attrs: { size: 32 } }, [
                                _vm._v(_vm._s(_vm.$MDI.ClockOutline)),
                              ])
                            : _c("v-icon", { attrs: { size: 32 } }, [
                                _vm._v(_vm._s(_vm.$MDI.HelpCircleOutline)),
                              ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.formattedDate(child.time)) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            _c("span", { staticClass: "mono" }, [
                              _vm._v(_vm._s(_vm.jobName(child.id) || child.id)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "history-delete-btn",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        title: "Remove from history",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.askDelete(child)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(_vm._s(_vm.$MDI.Close)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }
          ),
          _vm._v(" "),
          _c(
            "portal",
            [
              _c(
                "v-dialog",
                {
                  attrs: { width: "480px" },
                  model: {
                    value: _vm.deleteDialog,
                    callback: function ($$v) {
                      _vm.deleteDialog = $$v
                    },
                    expression: "deleteDialog",
                  },
                },
                [
                  _vm.pendingDelete
                    ? _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v("Remove this job from history?"),
                          ]),
                          _vm._v(" "),
                          _c("v-card-text", [
                            _c("span", { staticClass: "mono primary--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.jobName(_vm.pendingDelete.id) ||
                                    _vm.pendingDelete.id
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n                    will be removed from your history."
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("strong", [_vm._v("This cannot be undone.")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", text: "" },
                                  on: { click: _vm.cancelDelete },
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "error", text: "" },
                                  on: { click: _vm.performDelete },
                                },
                                [_vm._v("Delete")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }